import styled from "styled-components";

import { colorsPalettes, setElevation, setFontVariant } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const DrilldownWrapper = styled(Flex)`
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
`;

export const StyledEnrichButtonWrapper = styled(Flex)`
    align-items: center;
    gap: 2px;
    padding: 0 4px;
    border-radius: 4px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    cursor: pointer;
    height: 24px;
`;

export const ExpandedRowContent = styled.div`
    margin: 16px 4px;
    background-color: ${colorsPalettes.carbon[0]};
    border-radius: 6px;
    ${setElevation("Z1")};
`;

export const YearsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    margin: 12px;
`;

export const YearColumn = styled(Stack)`
    gap: 12px;
    padding: 16px;
    border-radius: 4px;
`;

export const MonthRow = styled(Flex)`
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;

export const SeeAdsLink = styled.a`
    ${setFontVariant("subtitle2", colorsPalettes.blue[400])}
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        text-decoration: underline;
        color: ${colorsPalettes.blue[400]};
    }
`;
